class Notifications {
    /**
     * Constructor
     * @param {HTMLElement} notificationEl
     */
    constructor(notificationEl) {
        this.el = notificationEl;

        this._init();
    }

    _init() {
        this.el.addEventListener('click', e => {
            if (this.el.classList.contains('has-notification')) {
                this.el.classList.add('active');
            }
        });

        const BTN_CLEAR = this.el.querySelector('.clear-all');

        if (BTN_CLEAR) {
            BTN_CLEAR.addEventListener('click', e => {
                e.preventDefault();
                const LINK   = e.target;
                const LOADER = new Loader({container: LINK, color: '#2966ad'});
                LOADER.show();

                const HTTP = new Http();
                HTTP.patch(LINK.getAttribute('href'), {}, false)
                    .then(() => {
                        this.el.querySelector('.button span').remove();
                        this.el.classList.remove('active', 'has-notification');
                        setTimeout(() => this.el.querySelector('.notification-list').remove(), 10000);
                        LOADER.hide();
                    });
            });
        }
    }
}